@if (videoPassedIn) {
  <div class="video-player-dialog-wrapper" cdkFocusRegionstart>
    <div class="close-btn-wrapper">
      <button mat-icon-button class="close-btn" aria-label="Close" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <video
      #dialogVideoPlayer
      id="dialogVideoPlayer"
      class="dialog-video-player"
      onloadstart="this.volume=0.4"
      crossorigin="anonymous"
      [poster]="videoPassedIn.placeholder_path"
      aria-label="Video"
      defaultplaybackrate="1"
      [src]="videoPassedIn.mp4_path"
      controls
      controlslist="nodownload"
      autoplay
      type="video/mp4"
      x-webkit-airplay="allow">
      <source src="videoPassedIn.mp4_path" type="video/mp4">
    </video>
  </div>
}